import { component } from 'picoapp'
import promobar from 'promobar'

export default component(({ node }) => {
  const promo = promobar(node, {
    content: node.querySelector('.js-content').innerHTML,
    lifespan: 1,
    resize: true,
    // placeholder: () => /products|posts/.test(window.location.pathname),
    offsets: [
      // document.getElementById('sideNav')
    ],
    close: [ node.querySelector('.js-close') ]
  })

  setTimeout(() => {
    promo.show()
  }, 2000)
})
